import axios from '@/plugins/axios';
import storeutils from '@/stores/utils';
import utils from '@/utils';
import Decimal from 'decimal.js';

const state = {
    invoiceitem: null,
    invoiceitem_saving: false,
    invoiceitem_saving_errors: {},
    vat_rate: null,
    step: "search",
    mode: "catalog",
    catalogentry: null,
    billed: null,
    invoice: null,
    invoice_id: null,
    invoice_side: "customer",
    invoices: null,
    invoices_loading: false,
    invoices_loading_errors: null,
};

const mutations = {

    updateInvoiceSide(state, side) {
        state.invoice_side = side === "provider" ? "provider" : "customer";
    },
    updateInvoiceItem(state, invoiceitem) {
        state.invoiceitem = invoiceitem || {};
        state.invoice_id = invoiceitem?.invoice;
        state.invoiceitem_saving = false;
        state.invoiceitem_saving_errors = {};

        state.vat_rate = state.invoiceitem.vat_rate ? utils.toPercent(state.invoiceitem.vat_rate) : null;
        if (state.invoiceitem.id) {
            state.step = "configure";
            if (state.invoiceitem.catalogentry) {
                state.catalogentry = state.invoiceitem.catalogentry;
            }
        }
    },

    updateCatalogEntry(state, catalogentry) {
        state.catalogentry = catalogentry;
        state.invoiceitem = {
            invoice: state.invoiceitem.invoice,
            customer: state.params.customer,
            catalogentry: catalogentry.id,
            unit_amount_excl_vat: catalogentry.unit_amount,
            count: 1,
            label: catalogentry.label,
        };
        if (state.invoiceitem.vat_rate) {
            state.vat_rate = utils.toPercent(state.invoiceitem.vat_rate);
        } else {
            state.vat_rate = null;
        }
    },

    updateInvoiceItemSaving(state, invoiceitem_saving) {
        state.invoiceitem_saving = invoiceitem_saving;
    },

    updateInvoiceItemSavingErrors(state, invoiceitem_saving_errors) {
        state.invoiceitem_saving_errors = invoiceitem_saving_errors;
    },

    updateInvoices(state, invoices) {
        state.invoices = invoices;
    },
    updateInvoicesLoading(state, loading) {
        state.invoices_loading = loading;
    },
    updateInvoicesLoadingErrors(state, errors) {
        state.invoices_loading_errors = errors;
    },
    updateInvoiceId(state, invoice_id) {
        state.invoice_id = invoice_id;
        state.invoiceitem.invoice = invoice_id;
    },
    updateInvoice(state, invoice) {
        state.invoice = invoice;
    },

    updateBilled(state, billed) {
        state.billed = billed;
    },

};

const actions = {

    async fetchInvoices({ commit, dispatch, state }, params) {
        commit('updateInvoices', []);
        if (state.invoice_side === 'provider') {
            commit('updateInvoicesLoading', false);
            return;
        }
        commit('updateInvoicesLoading', true);
        try {
            const response = await axios.get('/api/customerinvoices/', { params: { billed: state.billed, status: 'draft', 'ordering': '-invoice_date' } });
            commit('updateInvoices', response.data.results);
            return response.data;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateInvoicesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateInvoicesLoading', false);
        }
    },

    async fetchInvoice({ commit, dispatch, state }, params) {
        if (!state.invoice_id) {
            return;
        }

        commit('updateInvoice', null);

        try {
            const response = await axios.get(`/api/${state.invoice_side}invoices/${state.invoice_id}/`);
            commit('updateInvoice', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            throw error;
        }
    },


    async saveInvoiceItem({ commit, dispatch, state }, params) {

        commit('updateInvoiceItemSaving', true);
        let url = '/api/customerinvoiceitems/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/customerinvoiceitems/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            return response;
        } catch (xhr_error) {
            let error = storeutils.handleError(xhr_error);
            commit('updateInvoiceItemSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateInvoiceItemSaving', false);
            dispatch('billingstats/fetchAllStats', null, { root: true });
        }
    },

    async changeInvoiceId({ commit, dispatch, state }, invoice) {
        await commit('updateInvoiceId', invoice);
        await dispatch('fetchInvoice');
    },

    async init({ commit, dispatch, state }, params) {
        commit('updateInvoiceSide', params.side);
        commit('updateInvoiceItem', params.invoiceitem);
        commit('updateBilled', params.billed);
        if (params.invoice) {
            commit('updateInvoice', params.invoice);
        }
        dispatch('fetchInvoices');
        await commit('updateInvoiceId', params.invoiceitem.invoice);
        await dispatch('fetchInvoice');
    },
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
